import { EventEmitter, Optional, Output, Self, Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';

@Component({
    selector: 'superflex-calendar',
    template: `
        <label for="controltext"> {{ label }} <span *ngIf="ngControl.control.errors?.required" style="">*</span> </label>
        <p-calendar [formControl]='ngControl.control' dateFormat="dd/mm/yy" [readonlyInput]="true" [minDate]="minDate" [maxDate]="maxDate"
            [locale]="es" appendTo="body" [baseZIndex]="1000"  hourFormat="24" [showIcon]="true" showButtonBar="true" (onSelect)="this.onSelect.emit($event)">
        </p-calendar>
        <app-error [input]="ngControl.control"  [form]="form" ></app-error>
    `,
    host: { 'class': 'p-field' }
})
export class CalendarComponent implements OnInit, ControlValueAccessor {

    @Output() onSelect = new EventEmitter<any>()
    @Input() isDisabled: boolean = false
    @Input() showTime: boolean = false
    @Input() label: string = ''
    @Input() minDate: Date = null
    @Input() maxDate: Date = null

    @Input() set range(value:any[]){

        this.minDate = new Date(value[0])
        this.maxDate = new Date(value[0])
		this.maxDate.setDate(this.maxDate.getDate() + 30)

        if (this.ngControl.control) {
            if (this.minDate > this.ngControl.control.value || this.ngControl.control.value > this.maxDate) {
                this.ngControl.control.setValue(null)
            }
        }

    }

    es: any

    @Input() placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    public checked: boolean;
    public focused: boolean;

    form!: FormGroupDirective;

    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {
        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }

        this.es = {
            firstDayOfWeek: 0,
            dayNames: ['Sonday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
            dayNamesMin: ['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA'],
            monthNames: ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'],
            monthNamesShort: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
            today: 'Hoy',
            clear: 'Limpiar',
            weekHeader: 'Wk'
        }
    }

    public onModelTouched = () => {/** */ };

    ngOnInit(): void {
        this.ngControl.control.setValue(new Date())
    }

    writeValue(value: any): void {/** */ }
    registerOnChange(fn: any): void {/** */ }
    registerOnTouched(fn: any): void {/** */ }
    setDisabledState?(isDisabled: boolean): void {/** */ }

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }

    ngOnDestroy(): void {
        // this.registry.remove(this);
    }

    getPlaceholderPrefix(): string {
        return this.isDisabled ? '' : 'FORM_ERRORS.placeholder';
    }

}
